export default "__VITE_ASSET__DUPGD7Mm__"